export interface FaqItem {
  q: string;
  a: string;
}

/** Single source of truth for the FAQ page and its FAQPage JSON-LD (they must match). */
export const FAQ: FaqItem[] = [
  {
    q: "How do I send large files for free?",
    a: "Open limeshare.org, drop up to 3 files of up to 3 GB each, click Encrypt & get link, and share the link. No account, no email, no app. Files are encrypted in your browser before upload and deleted automatically after 48 hours (or sooner if you choose).",
  },
  {
    q: "Is LimeShare really zero-knowledge?",
    a: "Yes. A random 256-bit key is generated in your browser. Files, file names, sizes and your message are encrypted with keys derived from it. The key travels only in the part of the link after the # symbol, which browsers never send to servers. We store ciphertext, encrypted metadata and a hash of the access token — nothing that can be decrypted by us.",
  },
  {
    q: "What happens if I lose the link?",
    a: "The files cannot be recovered by anyone, including us — the decryption key exists only inside the link. Your browser keeps a local list of links you created (Sent from this browser) so you can copy them again on the same device.",
  },
  {
    q: "What does \"burn after first download\" do?",
    a: "The transfer becomes unavailable as soon as a recipient opens it, and the encrypted objects are deleted from storage right after the download finishes (or within 30 minutes at most). The link works exactly once.",
  },
  {
    q: "How is the password protection different from the link?",
    a: "With a password, the key inside the link is itself encrypted using Argon2id, a memory-hard password hashing function. Someone who intercepts the link still needs the password, which you send over a separate channel. The password never leaves the browsers involved.",
  },
  {
    q: "Which file types and sizes are supported?",
    a: "Any file type. Free anonymous transfers accept up to 3 files of 3 GB each. Larger limits (5 GB and 50 GB per file) come with free and paid accounts.",
  },
  {
    q: "Where are files stored and for how long?",
    a: "Encrypted objects are stored in zero-knowledge encrypted edge storage clusters and deleted by our scheduler exactly at expiry — 48 hours by default for anonymous transfers, or earlier if you choose 1, 6 or 24 hours, burn on first download, or destroy the transfer manually. Storage-level lifecycle rules act as a second safety net.",
  },
  {
    q: "Can LimeShare scan files for viruses or copyright?",
    a: "No — and that is the point. We cannot see the content, so we cannot scan it. We act on reports: every download page has a Report link, and reported transfers are removed quickly. Please scan downloaded files with your own antivirus as you would with any file from the internet.",
  },
  {
    q: "Does the recipient need an account or software?",
    a: "No. Any modern browser decrypts the files locally. On Chrome and Edge large files stream straight to disk; Firefox, Safari and Android use a streaming download through a service worker.",
  },
  {
    q: "Is the code open source?",
    a: "The client-side encryption library and the LSC1 container specification are published as open source with test vectors, so the security claims can be verified independently.",
  },
];
